import { useTranslate } from '@bynder/localization';
import { useWidgetStyleProperty } from './helpers';
import { SettingsAccordion } from './SettingsAccordion';
import { Thumbnail } from '@bynder/design-system';
import { IconBorder } from '@bynder/icons';
import InspectorBorderRadius from './InspectorBorderRadius';
import { CSS_PROPERTIES } from './constants';

const MediaBorderRadius: React.FC<{
  onEditStyle: (style: string) => void;
  style: string;
}> = ({ onEditStyle, style }) => {
  const { translate } = useTranslate();

  const handleStyleChange = (style: string) => {
    onEditStyle(style);
  };

  const { value: borderRadius, origin: borderRadiusOrigin } =
    useWidgetStyleProperty(
      style ?? '',
      'widgets.media.borderRadius',
      CSS_PROPERTIES.BORDER_RADIUS,
    );

  return (
    <SettingsAccordion
      noDivider
      thumbnail={<Thumbnail icon={<IconBorder />} />}
      title={translate('WIDGETS_INSPECTOR.BORDER_RADIUS')}
    >
      <InspectorBorderRadius
        style={style ?? ''}
        handleStyleChange={handleStyleChange}
        borderRadius={borderRadius}
        origin={borderRadiusOrigin}
      />
    </SettingsAccordion>
  );
};

export default MediaBorderRadius;
